/**
 * swagger-ui hardcodes a light background on its form controls (`#fff` for text
 * inputs and textareas, `#f7f7f7` for selects) but never declares a text
 * colour, so the controls fall back to the browser default for the active
 * `color-scheme`. Backstage's dark theme sets `color-scheme: dark`, which makes
 * that default light — light text on a light field. The most visible symptom is
 * the "Authorize" dialog, where a pasted API key is invisible.
 *
 * The field backgrounds stay light in both themes, so the text colour is pinned
 * to swagger-ui's own foreground colour instead of a palette value.
 *
 * These rules are global rather than scoped to a wrapper because the API
 * definition can also render inside a MUI dialog, which portals out of the
 * entity page tree.
 */
const swaggerUiFieldStyles = `
  .swagger-ui input[type='text']:not([disabled]),
  .swagger-ui input[type='password']:not([disabled]),
  .swagger-ui input[type='email']:not([disabled]),
  .swagger-ui input[type='search']:not([disabled]),
  .swagger-ui input[type='file']:not([disabled]),
  .swagger-ui select:not([disabled]),
  .swagger-ui textarea:not(.curl):not([disabled]) {
    color: #3b4151;
  }

  .swagger-ui input::placeholder,
  .swagger-ui textarea:not(.curl)::placeholder {
    color: #3b4151;
    opacity: 0.6;
  }
`;

export const SwaggerUiThemeStyles = () => <style>{swaggerUiFieldStyles}</style>;
